import { parseWidgetSpec, WidgetNode } from "@growth/editor";
import { Widget } from "@growth/widgets";
import { type NodeViewProps, NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { CircleAlert, Trash2 } from "lucide-react";

/** The same markup the blog publishes, plus a remove control. */
const WidgetNodeView = ({ node, deleteNode, selected }: NodeViewProps) => {
  const spec = parseWidgetSpec(node.attrs["spec"]);
  return (
    <NodeViewWrapper
      className={selected ? "cms-widget-node is-selected" : "cms-widget-node"}
      data-drag-handle
      contentEditable={false}
    >
      {spec ? (
        <Widget spec={spec} />
      ) : (
        <p className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
          <CircleAlert className="size-4" />
          This chart's data is no longer valid and won't be published.
        </p>
      )}
      <button
        type="button"
        onClick={deleteNode}
        aria-label="Remove chart"
        title="Remove chart"
        className="cms-widget-node__remove"
      >
        <Trash2 className="size-4" />
      </button>
    </NodeViewWrapper>
  );
};

export const EditorWidgetNode = WidgetNode.extend({
  addNodeView() {
    return ReactNodeViewRenderer(WidgetNodeView);
  },
});
